import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createJob } from "../redux/features/job/jobSlice";
import formatDate from "../utils/formatDate";

export default function AddJob() {
  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [salary, setSalary] = useState("");
  const [deadline, setDeadline] = useState("");
  const { isLoading, isError } = useSelector((state) => state.job);
  const [message, setMessage] = useState("");

  const dispatch = useDispatch();

  const handleCreate = (e) => {
    e.preventDefault();

    // Did not go beyond, just added the required
    // You can check the utils/extra.js
    function validate() {
      const today = new Date(formatDate(new Date())).valueOf();
      const date = new Date(formatDate(new Date(deadline))).valueOf();

      if (salary < 0) {
        setMessage("Please insert a valid salary!");
        return false;
      }

      if (date < today) {
        setMessage("Deadline requires an upcoming date!");
        return false;
      }
      if (title !== "" && type !== "" && salary !== "" && deadline !== "") {
        return true;
      }
    }

    if (validate()) {
      dispatch(
        createJob({
          title,
          type,
          salary: Number(salary),
          deadline: formatDate(deadline),
        })
      );

      if (isError) {
        setMessage("There was an error occurred.");
      } else {
        setMessage(
          `Job has been successfully added on ${new Date().toLocaleTimeString()}.`
        );

        setTimeout(() => {
          e.target.reset();
        }, 200);
      }
    }
  };

  return (
    <div className="lg:pl-[14rem] mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <h1 className="mb-10 text-center lws-section-title">Add New Job</h1>

        <div className="max-w-3xl mx-auto">
          <form className="space-y-6" onSubmit={handleCreate}>
            <div className="fieldContainer">
              <label
                htmlFor="lws-JobTitle"
                className="text-sm font-medium text-slate-300"
              >
                Job Title
              </label>
              <select
                id="lws-JobTitle"
                name="lwsJobTitle"
                required
                onChange={(e) => setTitle(e.target.value)}
              >
                <option value="" hidden>
                  Select Job
                </option>
                <option>Software Engineer</option>
                <option>Software Developer</option>
                <option>Full Stack Developer</option>
                <option>MERN Stack Developer</option>
                <option>DevOps Engineer</option>
                <option>QA Engineer</option>
                <option>Product Manager</option>
                <option>Social Media Manager</option>
                <option>Senior Executive</option>
                <option>Junior Executive</option>
                <option>Android App Developer</option>
                <option>IOS App Developer</option>
                <option>Frontend Developer</option>
                <option>Frontend Engineer</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobType">Job Type</label>
              <select
                id="lws-JobType"
                name="lwsJobType"
                required
                onChange={(e) => setType(e.target.value)}
              >
                <option value="" hidden>
                  Select Job Type
                </option>
                <option>Full Time</option>
                <option>Internship</option>
                <option>Remote</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobSalary">Salary</label>
              <div className="flex border rounded-md shadow-sm border-slate-600">
                <span className="input-tag">BDT</span>
                <input
                  type="number"
                  name="lwsJobSalary"
                  id="lws-JobSalary"
                  required
                  className="!rounded-l-none !border-0"
                  placeholder="20,00,000"
                  onChange={(e) => setSalary(e.target.value)}
                />
              </div>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobDeadline">Deadline</label>
              <input
                type="date"
                name="lwsJobDeadline"
                id="lws-JobDeadline"
                required
                onChange={(e) => setDeadline(e.target.valueAsDate)}
              />
            </div>

            <div className="text-right">
              <button
                type="submit"
                id="lws-submit"
                className="cursor-pointer btn btn-primary w-fit"
                disabled={isLoading}
              >
                Save
              </button>
            </div>
            <p
              style={{
                color: message.includes("Job has been successfully added")
                  ? "yellow"
                  : "red",
              }}
            >
              {message}
            </p>
          </form>
        </div>
      </main>
    </div>
  );
}
